import React from 'react'
import { useFormik } from 'formik'
import { useVoucherForm } from '../hooks/useVoucherForm'
import Card from 'components/card/Card'
import CardHeaderForm from 'components/card/CardHeaderForm'
import Button from 'components/button/Button'
import FormSection1 from '../components/voucher/FormSection1'
import FormSection2 from '../components/voucher/FormSection2'
import FormSection3 from '../components/voucher/FormSection3'
import { validationSchemaFormVoucher } from 'helpers/validation'

export default function CreateVoucher() {
  const useVoucherFormHook = useVoucherForm()

  const formik = useFormik({
    initialValues: useVoucherFormHook.voucherForm,
    validateOnBlur: true,
    validationSchema: validationSchemaFormVoucher,
    onSubmit: async values => {
      await useVoucherFormHook.createVoucher(values)
    },
  })

  const loading = useVoucherFormHook.statusFetchVoucher === 'loading'

  return (
    <div className="content-wrapper">
      {useVoucherFormHook.toastContainer}
      <Card className="bg-transparent p-0" dataTestId="card_voucherForm" loading={loading}>
        <Card className="rounded-xl py-6 px-0 mb-4" dataTestId="card_formSection1">
          <CardHeaderForm title="1. Informasi Voucher" />
          <Card.Body className="mt-0 px-6">
            <FormSection1 formikProps={formik} />
          </Card.Body>
        </Card>
        <Card className="rounded-xl py-6 px-0 mb-4" dataTestId="card_formSection2">
          <CardHeaderForm title="2. Pengaturan Voucher" />
          <Card.Body className="mt-0 px-6">
            <FormSection2 formikProps={formik} />
          </Card.Body>
        </Card>
        <Card className="rounded-xl py-6 px-0" dataTestId="card_formSection3">
          <CardHeaderForm title="3. Kriteria Voucher" />
          <Card.Body className="mt-0 px-6">
            <FormSection3
              formikProps={formik}
              statusFetchStockLocations={useVoucherFormHook.statusFetchStockLocations}
              statusFetchCategories={useVoucherFormHook.statusFetchCategories}
              tableHeight={useVoucherFormHook.maxHeightTable}
              tableContainerRef={useVoucherFormHook.tableContainerRef}
              stockLocations={useVoucherFormHook.stockLocations}
              categories={useVoucherFormHook.categories}
              fetchStockLocations={useVoucherFormHook.fetchStockLocation}
              fetchCategories={useVoucherFormHook.fetchCategories}
              resetFetchStockLocation={useVoucherFormHook.resetFetchStockLocations}
            />
          </Card.Body>
        </Card>
        <div className="mt-4 flex justify-end">
          <Button
            data-testid="button_addVoucher"
            variant="solid-primary"
            label="Buat Voucher"
            className="py-4 px-6 text-sm"
            onClick={formik.handleSubmit}
          />
        </div>
      </Card>
    </div>
  )
}
